import { twMerge } from "tailwind-merge";
import {
  CatalogLink,
  CatalogAutoplayButton,
  CatalogPagingButton,
} from "catalog/CatalogNavigations";
import { useParams } from "react-router-dom";
import { useState, useEffect } from "react";
import { Image } from "components/elements/index";
import { useCatalog } from "catalog/Catalog.context";

export default function GlobalNavigation() {
  const { pageSlug1, pageSlug2 } = useParams();
  const { activePageInfo } = useCatalog();
  const { depth1, depth2, gnb, logo, next_control, prev_control } = activePageInfo;
  const isSlugIntro2 = pageSlug1 === "intro" && pageSlug2 == 2;
  const isMobile = window.innerWidth <= 768;
  const [viewMobileMenu, setMobileMenu] = useState(false);
  const handleMobileMenu = () => {
    setMobileMenu((prev) => !prev);
  };
  const check = (
    <svg width="17.643" height="15.171" viewBox="0 0 17.643 15.171">
      <defs>
        <clipPath id="clip-path">
          <rect
            id="사각형_48450"
            data-name="사각형 48450"
            width="17.643"
            height="15.171"
            transform="translate(0 0)"
            fill="#ff0aad"
          />
        </clipPath>
      </defs>
      <g id="그룹_21476" data-name="그룹 21476" clipPath="url(#clip-path)">
        <path
          id="패스_431"
          data-name="패스 431"
          d="M5.355,9.917c-.072-.151-.146-.3-.223-.443A47.507,47.507,0,0,0,2.194,5.448L0,8.373a21.915,21.915,0,0,1,3.2,3.884,23.879,23.879,0,0,1,1.075,2.914L6.69,14.2A38.831,38.831,0,0,1,9.262,7.855C12.893,1.607,17.643,0,17.643,0S13.765.313,9.7,4.219a26.767,26.767,0,0,0-4.346,5.7"
          transform="translate(0 0)"
          fill="#ff0aad"
        />
      </g>
    </svg>
  );

  return (
    <div className="pointer-events-none fixed top-0 z-[9999] h-full w-full">
      <header className=" z-[999] flex h-[50px] w-full items-center justify-between gap-8 bg-white px-[20px] shadow-md *:pointer-events-auto  md:h-[100px]  md:bg-transparent md:px-[70px] md:shadow-none">
        <CatalogLink
          to="/"
          className={twMerge(
            "text-4xl font-bold md:mt-auto",
            logo === "hide" && "translate-y-[-100px]",
          )}
        >
          <div className="md:bg:0 relative mb-3.5 w-[100px] md:w-[184px]">
            <Image src="/logo-white.png" alt="logo" className="absolute inset-0 hidden md:block" />
            <Image src="/logo-blue.png" alt="logo" className="absolute inset-0 block md:hidden" />
          </div>
        </CatalogLink>
        <div className="flex items-center gap-12 pt-0 md:pt-10">
          <nav className="flex gap-4 text-xl">
            <CatalogLink to="catalog-index" className="  flex items-center justify-center">
              <MenuIcon isSlugIntro2={isSlugIntro2} isMobile={isMobile} />
            </CatalogLink>

            <CatalogAutoplayButton
              className={twMerge(
                "flex h-7 w-7 items-center justify-center rounded border-2",
                isSlugIntro2 && !isMobile ? "border-white" : "border-gray-500",
              )}
              render={{
                play: (
                  <svg xmlns="http://www.w3.org/2000/svg" width="8" height="12" viewBox="0 0 7 11">
                    <path
                      id="다각형_8"
                      data-name="다각형 8"
                      d="M5.107.5a.5.5,0,0,1,.786,0l4.471,5.691A.5.5,0,0,1,9.971,7H1.029a.5.5,0,0,1-.393-.809Z"
                      transform="translate(7) rotate(90)"
                      fill={isSlugIntro2 && !isMobile ? "#fff" : "#8e8e8e"}
                    />
                  </svg>
                ),
                pause: (
                  <svg xmlns="http://www.w3.org/2000/svg" width="9" height="11" viewBox="0 0 9 11">
                    <line
                      id="선_18"
                      data-name="선 18"
                      y2="9"
                      transform="translate(1 1)"
                      fill={isSlugIntro2 && !isMobile ? "#fff" : "#8e8e8e"}
                      stroke={isSlugIntro2 && !isMobile ? "#fff" : "#8e8e8e"}
                      strokeLinecap="round"
                      strokeWidth="2"
                    />
                    <line
                      id="선_19"
                      data-name="선 19"
                      y2="9"
                      transform="translate(8 1)"
                      fill={isSlugIntro2 && !isMobile ? "#fff" : "#8e8e8e"}
                      stroke={isSlugIntro2 && !isMobile ? "#fff" : "#8e8e8e"}
                      strokeLinecap="round"
                      strokeWidth="2"
                    />
                  </svg>
                ),
              }}
            />
          </nav>
        </div>
      </header>

      {pageSlug1 !== "intro" && pageSlug1 !== "cover" && (
        <div
          className={twMerge(
            "gnb-side-bar hidden md:block",
            gnb !== "hide" ? "active" : "hide",
            "pointer-events-auto",
            pageSlug2 === "precision" ? "theme-cyan" : "",
          )}
        >
          <nav className="index">
            <h4 className={twMerge(pageSlug1 === "company" && "active", "gnb")}>COMPANY</h4>
            <div className="lnb-index">
              <CatalogLink
                className={twMerge(pageSlug2 === "overview" && "active", "lnb")}
                to="company/overview"
              >
                <span className="square">{check}</span> Overview
              </CatalogLink>
              <CatalogLink
                className={twMerge(pageSlug2 === "history" && "active", "lnb")}
                to="company/history"
              >
                <span className="square">{check}</span> History
              </CatalogLink>
            </div>
          </nav>
          <nav className="index">
            <h4 className={twMerge(pageSlug1 === "research" && "active", "gnb")}>
              Research &<br />
              Development
            </h4>
            <div className="lnb-index">
              <CatalogLink
                className={twMerge(pageSlug2 === "patents" && "active", "lnb")}
                to="/research/patents"
              >
                <span className="square">{check}</span> Patents & Certifications
              </CatalogLink>
              <CatalogLink
                className={twMerge(pageSlug2 === "papers" && "active", "lnb")}
                to="research/papers/2023"
              >
                <span className="square">{check}</span> Papers
              </CatalogLink>
            </div>
          </nav>
          <nav className="index">
            <h4 className={twMerge(pageSlug1 === "product" && "active", "gnb")}>Product</h4>
            <div className="lnb-index">
              <CatalogLink
                className={twMerge(pageSlug2 === "precision" && "active", "lnb")}
                to="product/precision/1"
              >
                <span className="square">{check}</span> Precision flow regulator
              </CatalogLink>
              <CatalogLink
                className={twMerge(pageSlug2 === "automatic" && "active", "lnb")}
                to="product/automatic/accu-drip/1"
              >
                <span className="square">{check}</span> Automatic Infusion Controller
              </CatalogLink>
            </div>
          </nav>
          <nav className="index">
            <h4 className={twMerge(pageSlug1 === "contact" && "active", "gnb")}>Contact</h4>
            <div className="lnb-index">
              <CatalogLink
                className={twMerge(pageSlug1 === "contact" && "active", "lnb")}
                to="contact/info"
              >
                <span className="square">{check}</span> Contact
              </CatalogLink>
            </div>
          </nav>
        </div>
      )}

      {isMobile && pageSlug1 !== "intro" && pageSlug1 !== "cover" && (
        <div
          className={twMerge(
            "gnb-side-bar moView",
            viewMobileMenu && "active",
            // gnb !== "hide" ? "active" : "hide",
            " pointer-events-auto",
            pageSlug2 === "precision" ? "theme-cyan" : "",
          )}
          onClick={handleMobileMenu}
        >
          <nav className="index">
            <h4 className={twMerge(pageSlug1 === "company" && "active", "gnb")}>COMPANY</h4>
            <div className="lnb-index">
              <CatalogLink
                className={twMerge(pageSlug2 === "overview" && "active", "lnb")}
                to="company/overview"
              >
                <span className="square">{check}</span> Overview
              </CatalogLink>
              <CatalogLink
                className={twMerge(pageSlug2 === "history" && "active", "lnb")}
                to="company/history"
              >
                <span className="square">{check}</span> History
              </CatalogLink>
            </div>
          </nav>
          <nav className="index">
            <h4 className={twMerge(pageSlug1 === "research" && "active", "gnb")}>
              Research &<br />
              Development
            </h4>
            <div className="lnb-index">
              <CatalogLink
                className={twMerge(pageSlug2 === "patents" && "active", "lnb")}
                to="/research/patents"
              >
                <span className="square">{check}</span> Patents & Certifications
              </CatalogLink>
              <CatalogLink
                className={twMerge(pageSlug2 === "papers" && "active", "lnb")}
                to="research/papers/2023"
              >
                <span className="square">{check}</span> Papers
              </CatalogLink>
            </div>
          </nav>
          <nav className="index">
            <h4 className={twMerge(pageSlug1 === "product" && "active", "gnb")}>Product</h4>
            <div className="lnb-index">
              <CatalogLink
                className={twMerge(pageSlug2 === "precision" && "active", "lnb")}
                to="product/precision/1"
              >
                <span className="square">{check}</span> Precision flow regulator
              </CatalogLink>
              <CatalogLink
                className={twMerge(pageSlug2 === "automatic" && "active", "lnb")}
                to="product/automatic/accu-drip/1"
              >
                <span className="square">{check}</span> Automatic Infusion Controller
              </CatalogLink>
            </div>
          </nav>
          <nav className="index">
            <h4 className={twMerge(pageSlug1 === "contact" && "active", "gnb")}>Contact</h4>
            <div className="lnb-index">
              <CatalogLink
                className={twMerge(pageSlug1 === "contact" && "active", "lnb")}
                to="contact/info"
              >
                <span className="square">{check}</span> Contact
              </CatalogLink>
            </div>
          </nav>
        </div>
      )}
      <nav
        className={twMerge(
          "absolute bottom-0 left-0 z-50 flex w-full justify-between px-5 py-5 *:pointer-events-auto md:px-14 md:py-14",
          isMobile && pageSlug2 != 2 && "bg-white/50 backdrop-blur-sm",
        )}
      >
        <CatalogPagingButton
          direction="prev"
          className={twMerge("disabled:opacity-50", prev_control === "hide" && "hidden")}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width={isMobile ? "29.778" : "36.278"}
            height={isMobile ? "26.099" : "32.599"}
            viewBox="0 0 27.906 25.076"
          >
            <g id="그룹_22841" data-name="그룹 22841" transform="translate(1.414 1.414)">
              <path
                id="패스_553"
                data-name="패스 553"
                d="M15.732,0V15.732H0"
                transform="translate(22.248 11.124) rotate(135)"
                fill="none"
                stroke="#c9c9c9"
                strokeLinecap="round"
                strokeMiterlimit="10"
                strokeWidth="2"
              />
              <line
                id="선_913"
                data-name="선 913"
                x1="25.275"
                transform="translate(0.217 10.912)"
                fill="none"
                stroke="#c9c9c9"
                strokeLinecap="round"
                strokeWidth="2"
              />
            </g>
          </svg>
        </CatalogPagingButton>
        {pageSlug1 !== "intro" &&
          pageSlug1 !== "cover" &&
          pageSlug1 !== "catalog-index" &&
          pageSlug1 !== "last" && (
            <button
              onClick={handleMobileMenu}
              className=" flex h-6 w-11 flex-col justify-center gap-1 rounded-full bg-[#fff] px-3  md:hidden"
            >
              <span className="block h-[2px] w-full bg-[#2190F1] "></span>
              <span className="block h-[2px] w-full bg-[#2190F1]"></span>
            </button>
          )}
        <CatalogPagingButton
          direction="next"
          className={twMerge("disabled:opacity-50", next_control === "hide" && "hidden")}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width={isMobile ? "29.778" : "36.278"}
            height={isMobile ? "26.099" : "32.599"}
            viewBox="0 0 27.905 25.076"
          >
            <path
              id="패스_554"
              data-name="패스 554"
              d="M15.732,15.732V0H0"
              transform="translate(15.367 1.414) rotate(45)"
              fill="none"
              stroke="#2190f1"
              strokeLinecap="round"
              strokeMiterlimit="10"
              strokeWidth="2"
            />
            <line
              id="선_914"
              data-name="선 914"
              x2="25.275"
              transform="translate(1 12.326)"
              fill="none"
              stroke="#2190f1"
              strokeLinecap="round"
              strokeWidth="2"
            />
          </svg>
        </CatalogPagingButton>
      </nav>
    </div>
  );
}

function MenuIcon({ isSlugIntro2, isMobile }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="26.654"
      height="22.767"
      viewBox="0 0 26.654 22.767"
    >
      <line
        id="선_70"
        data-name="선 70"
        x2="24.654"
        transform="translate(1 1)"
        fill="none"
        stroke={isSlugIntro2 && !isMobile ? "#fff" : "#8e8e8e"}
        strokeLinecap="round"
        strokeWidth="2.5"
      />
      <line
        id="선_68"
        data-name="선 68"
        x2="24.654"
        transform="translate(1 21.767)"
        fill="none"
        stroke={isSlugIntro2 && !isMobile ? "#fff" : "#8e8e8e"}
        strokeLinecap="round"
        strokeWidth="2.5"
      />
      <line
        id="선_69"
        data-name="선 69"
        x2="24.654"
        transform="translate(1 11.383)"
        fill="none"
        stroke={isSlugIntro2 && !isMobile ? "#fff" : "#8e8e8e"}
        strokeLinecap="round"
        strokeWidth="2.5"
      />
    </svg>
  );
}
